import React from "react";

export default function LearningResourceChips({ youtube, youtubeTitle, article }) {
  if (!youtube && !article) return null;
  const row = (href, label, bg, color, border, caption) => (
    <div key={label} style={{ display: "flex", flexDirection: "column", gap: 4, minWidth: 0 }}>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        style={{
          display: "inline-flex",
          alignItems: "center",
          width: "fit-content",
          gap: 6,
          padding: "5px 10px",
          borderRadius: 8,
          background: bg,
          color,
          border: `1px solid ${border}`,
          fontSize: 11.5,
          fontWeight: 750,
          textDecoration: "none",
        }}
      >
        {label}
      </a>
      {caption ? (
        <div style={{ fontSize: 11.5, fontWeight: 650, color: "#374151", lineHeight: 1.35 }}>{caption}</div>
      ) : null}
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        style={{
          fontSize: 11,
          fontWeight: 600,
          color: "#1D4ED8",
          wordBreak: "break-all",
          lineHeight: 1.4,
        }}
      >
        {href}
      </a>
    </div>
  );
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 10 }}>
      {youtube ? row(youtube, "Watch video", "#FEF2F2", "#B91C1C", "#FECACA", youtubeTitle) : null}
      {article ? row(article, "Open article", "#EEF2FF", "#3730A3", "#C7D2FE") : null}
    </div>
  );
}
